module.exports = __webpack_public_path__ + "static/media/CERRO-VERDE-AEREA.dc93c1fa.jpg";